import { withStyles } from '@material-ui/core';
import TourHours from './TourHours';
import styles from './styles';

export default withStyles(styles)(TourHours);
